import React from 'react';
import MetaTags from '../../components/layout/MetaTags';
import Header from '../../components/layout/Header';
import HeroSection from '../../sections/HeroSection';
import ProgramSection from '../../sections/ProgramSection';
import BeritaSection from '../../sections/BeritaSection';
import YouTubeSection from '../../sections/YouTubeSection';
import AlumniSection from '../../sections/AlumniSection';
import CTASection from '../../sections/CTASection';
import Footer from '../../components/layout/Footer';
import './Homepage.css';

const Homepage = () => {
  return (
    <div className="homepage">
      <MetaTags 
        title="Pondok Pesantren Bahrul Ulum - Islamic Centre Sungailiat"
        description="Membentuk generasi unggul yang cerdas, berdaya saing, dan berakhlak mulia melalui pendidikan Islami terpadu."
      />
      
      <Header />
      
      <main>
        <HeroSection />
        <ProgramSection />
        <BeritaSection />
        <YouTubeSection />
        <AlumniSection />
        <CTASection />
      </main>
      
      <Footer />
    </div>
  );
};

export default Homepage;
